import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext({ user: undefined, login: async () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
    // undefined = still checking; null/false = anonymous; obj = logged in
    const [user, setUser] = useState(undefined);

    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem("pck_token");
        if (!token) {
            setUser(null);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (_e) {
            localStorage.removeItem("pck_token");
            setUser(null);
        }
    }, []);

    useEffect(() => {
        bootstrap();
    }, [bootstrap]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data?.token) localStorage.setItem("pck_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (_e) {
            /* ignore */
        }
        localStorage.removeItem("pck_token");
        setUser(null);
    };

    return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
